import { useState, useEffect } from 'react';
import { Text, Flex, Box, Badge } from '@chakra-ui/react';
import { FaClock } from 'react-icons/fa';

const ClockInTimer = ({ clockInTime, clockOutTime }) => {
  const [elapsedTime, setElapsedTime] = useState('');

  useEffect(() => {
    if (!clockInTime) return;

    const updateTimer = () => {
      const now = clockOutTime ? new Date(clockOutTime) : new Date();
      const clockIn = new Date(clockInTime);
      const diff = now - clockIn;

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      setElapsedTime(`${hours}h ${minutes}m ${seconds}s`);
    };

    updateTimer();
    let interval;
    
    if (!clockOutTime) {
      interval = setInterval(updateTimer, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [clockInTime, clockOutTime]);

  return clockInTime ? (
    <Flex 
      align="center" 
      bg="green.50" 
      p={2} 
      borderRadius="md" 
      mt={1}
      maxW="fit-content"
    >
      <FaClock color="#38A169" size="14px" />
      <Box ml={2}>
        <Badge colorScheme="green" fontSize="xs" mb={1}>
          {clockOutTime ? 'Clocked Out' : 'Clocked In'}
        </Badge>
        <Text fontSize="xs" color="gray.600">
          {new Date(clockOutTime || clockInTime).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
          <Text as="span" fontWeight="medium" ml={1}>
            ({elapsedTime})
          </Text>
        </Text>
      </Box>
    </Flex>
  ) : null;
};

export default ClockInTimer;
